import store from "@/store";
import { SiteModel } from "@/models/SiteModel";
import ApiQueue from "@/libraries/ApiQueue";
import FallbackDB from "@/libraries/localStorage";
import { addMagicMethods } from "@/helpers/addMagicMethods";
export class UserModel extends SiteModel {
    constructor(id = null) {
        super('users', +id);
        return addMagicMethods(this);
    }
    getTableData() {
        return store.getters['users/getDB'] || [];
    }
    setTableData(data) {
        store.commit('users/setDB', data);
        FallbackDB.save('users', data);
    }
    static onSuccessSubmit(response) {
        return super.onSuccessSubmit('UserModel', response);
    }
    flush() {
        return super.flush('UserModel', 'users');
    }
    __get(target, prop, receiver) {
        switch (prop) {
            case 'full_name':
                return [receiver.surname, receiver.first_name, receiver.patronymic].filter(v => !!v).join(' ');
            case 'avatar_full_url':
                return `/upl/users/${receiver.avatar}`;
        }
        return super.__get(target, prop, receiver);
    }
    __set(target, prop, value, receiver) {
        switch (prop) {
            case 'new_password':
                target.data.new_password = value;
                break;
            default:
                super.__set(target, prop, value, receiver);
        }
        return true;
    }
    static current() {
        return new UserModel(store.getters['users/getCurrentUserID']);
    }
    static isAuth() {
        var _a;
        return !!((_a = UserModel.current()) === null || _a === void 0 ? void 0 : _a.id);
    }
    static async tryLogin(login_or_name, password) {
        try {
            const response = await ApiQueue.post('login', {
                login_or_name,
                password
            }, ApiQueue.REPLACE_EQUAL + ApiQueue.HIGH_PRIORITY);
            const me = new UserModel(response.id);
            me.setData(response);
            me.flush();
            store.commit('users/setCurrentUserID', +response.id);
        }
        catch (e) {
            throw e;
        }
    }
    async logout() {
        FallbackDB.remove('ajax_requests');
        ApiQueue.queue = [];
        store.commit('users/setCurrentUserID', 0);
        FallbackDB.remove('users');
        FallbackDB.remove('work_intervals');
        FallbackDB.remove('tasks');
        FallbackDB.remove('params');
        FallbackDB.remove('shifts');
        window.location.replace('/');
    }
    static isTester() {
        var _a;
        const testAccounts = [
            'zmigpost@gmail.com',
            'director@abis39.ru',
            'worker-testov.t.t@kkosa.ru',
        ];
        return testAccounts.includes((_a = UserModel.current()) === null || _a === void 0 ? void 0 : _a.email);
    }
}
window.UserModel = UserModel;
